//I've decided to do this page NOT by venue, but just a long list
import React, { useState, useEffect, useContext } from 'react'
import './FullSchedule.css'
import './FullScheduleCards.css'
import { useParams, Link, NavLink } from 'react-router-dom'
import { AuthContext } from '../context/auth-context'
import Footer from '../components/UIElements/Footer'
import LoadingSpinner from '../components/UIElements/LoadingSpinner'
import SchedulesHomeNavigation from '../components/Navigation/SchedulesHomeNavigation'
import SearchByLeagueOrVenue from '../components/UIElements/SearchByLeagueOrVenue'
//import SelectLeagueSchedule from '../components/UIElements/SelectLeagueSchedule'
import FilterByTeam from '../components/UIElements/FilterByTeam'
import Banner from '../components/Navigation/Banner'
import FL from '../../images/FL.png'
import MA from '../../images/MA.png'
import MI from '../../images/MI.png'
import MN from '../../images/MN.png'
import NC from '../../images/NC.png'
import NH from '../../images/NH.png'
import NJ from '../../images/NJ.png'
import NY from '../../images/NY.png'
import PA from '../../images/PA.png'
import QC from '../../images/QC.png'
import PHX from '../../images/PHX.PNG'

const DivisionSchedule = () => {
	console.log('inside DivisionSchedule')

	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [allDivisionGamesAndEvents, setAllDivisionGamesAndEvents] = useState([])
	const [leagueId, setLeagueId] = useState()
	const [leagueName, setLeagueName] = useState()
	const [divisionName, setDivisionName] = useState()
	const [year, setYear] = useState()
	const [allPotentialPlayoffGames, setAllPotentialPlayoffGames] = useState()
	const auth = useContext(AuthContext)

	const divisionId = useParams().divisionId

	//Get all games scheduled in this division.  league-controller  getDivisionSchedule
	useEffect(() => {
		//
		//console.log('INSIDE USE EFFECT')
		const sendRequest = async () => {
			setIsLoading(true)
			setAllDivisionGamesAndEvents([])
			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/league/division/${divisionId}/schedule`,
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				/* setAllVenueGamesAndEvents(
					responseData.allVenueGamesAndEventsArrayThreeWeeks
				) */
				setAllDivisionGamesAndEvents(
					responseData.allDivisionGamesAndEventsArray,
				)
				setLeagueId(responseData.leagueId)
				setLeagueName(responseData.leagueName)
				setAllPotentialPlayoffGames(responseData.allPotentialPlayoffGamesArray)
				setDivisionName(responseData.divisionName)
				setYear(responseData.year)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [divisionId])
	//
	//
	console.log(
		'allDivisionGamesAndEvents: ' + JSON.stringify(allDivisionGamesAndEvents),
	)
	//
	//
	//
	const teamLogoMap = {
		Florida: FL,
		Massachusetts: MA,
		Minnesota: MN,
		Michigan: MI,
		'North Carolina': NC,
		'New Hampshire': NH,
		'New Jersey': NJ,
		'New Jersey 1': NJ,
		'New Jersey 2': NJ,
		'New York': NY,
		'Team Quebec': QC,
		'Team Quebec 1': QC,
		'Team Quebec 2': QC,
		Pennsylvania: PA,
		'Niagara Phoenix': PHX,
		'Ontario Phoenix': PHX,
	}
	//
	//
	const formatGameDate = (game) => {
		const months = {
			'01': 'Jan.',
			'02': 'Feb.',
			'03': 'Mar.',
			'04': 'Apr.',
			'05': 'May',
			'06': 'June',
			'07': 'July',
			'08': 'Aug.',
			'09': 'Sept.',
			10: 'Oct.',
			11: 'Nov.',
			12: 'Dec.',
		}

		return `${game.dayOfWeek}, ${months[game.date.substr(0, 2)]} ${game.date.substr(3, 2)}`
	}

	const formatGameTime = (game) => {
		const hour = game.time.substr(0, 2)
		const minute = game.time.substr(3, 2)

		const times = {
			'00': `12:${minute} am`,
			'01': `1:${minute} am`,
			'02': `2:${minute} am`,
			'03': `3:${minute} am`,
			'04': `4:${minute} am`,
			'05': `5:${minute} am`,
			'06': `6:${minute} am`,
			'07': `7:${minute} am`,
			'08': `8:${minute} am`,
			'09': `9:${minute} am`,
			10: `10:${minute} am`,
			11: `11:${minute} am`,
			12: `12:${minute} pm`,
			13: `1:${minute} pm`,
			14: `2:${minute} pm`,
			15: `3:${minute} pm`,
			16: `4:${minute} pm`,
			17: `5:${minute} pm`,
			18: `6:${minute} pm`,
			19: `7:${minute} pm`,
			20: `8:${minute} pm`,
			21: `9:${minute} pm`,
			22: `10:${minute} pm`,
			23: `11:${minute} pm`,
			24: `12:${minute} am`,
		}

		return times[hour]
	}

	const getDivisionLabel = (game) => {
		return game.playoff ? game.playoffDivision : game.divisionName
	}

	const getDisplayScore = (game) => {
		if (!game.score) {
			return 'TBP'
		}

		const scoreParts = game.score.split('-').map((score) => score.trim())

		if (scoreParts.length !== 2) {
			return game.score
		}

		const leftScore = Number(scoreParts[0])
		const rightScore = Number(scoreParts[1])

		if (Number.isNaN(leftScore) || Number.isNaN(rightScore)) {
			return game.score
		}

		if (game.winner === game.homeTeamId) {
			return `${Math.max(leftScore, rightScore)} - ${Math.min(leftScore, rightScore)}`
		}

		if (game.winner === game.visitorTeamId) {
			return `${Math.min(leftScore, rightScore)} - ${Math.max(leftScore, rightScore)}`
		}

		return `${leftScore} - ${rightScore}`
	}
	//
	//
	const errorHandler = () => {
		setError(null)
	}
	//
	//
	if (isLoading) {
		return (
			<div className='center' style={{ marginTop: '10rem' }}>
				<LoadingSpinner />
			</div>
		)
	}
	//
	//
	//
	let dateBlock
	dateBlock = []
	if (!isLoading && allDivisionGamesAndEvents.length === 0) {
		return (
			<React.Fragment>
				{/* <AdminNavigation /> */}
				<SchedulesHomeNavigation />
				{/* <SearchByLeagueOrVenue /> */}
				{/* <div style={{ marginBottom: '2rem' }}>
					<FilterByTeam leagueId={leagueId} />
				</div> */}
				<SearchByLeagueOrVenue />
				<div className='Leagues'>
					<h1>NOTHING SCHEDULED YET!</h1>
				</div>
				<div style={{ marginTop: '16rem' }}>
					<Footer />
				</div>
			</React.Fragment>
		)
	}
	if (!isLoading && allDivisionGamesAndEvents.length !== 0) {
		// distinctVenuesArray.forEach((venue) => {
		//allLeagueGames.forEach((game) => {
		dateBlock.push(
			<React.Fragment>
				<div className='Schedule'>
					<div className='divisionScheduleHeroMobile'>
						<div className='divisionScheduleHeroTournament'>
							{leagueName} {year}
						</div>

						<h1>{allDivisionGamesAndEvents[0].divisionName}</h1>

						<div className='divisionScheduleHeroLine'></div>

						<p>Click on the final score of a game to see a Game Summary.</p>
					</div>

					<div className='divisionScheduleDesktopTitle'>
						<h1>{allDivisionGamesAndEvents[0].divisionName}</h1>
						<h5>
							{year} {leagueName}
						</h5>
						<p className='clickOn'>
							(Click on the final score of a game to see a Game Summary)
						</p>
					</div>
					<table id='divisionTable'>
						<thead>
							<tr>
								<th>Date/Time/Location</th>
								<th>Visitor/Home</th>
								<th></th>
								{auth.isLoggedIn && <th></th>}
								<th>Winner</th>
								<th>Score</th>
							</tr>
						</thead>
						<tbody>
							{allDivisionGamesAndEvents.map((game, key) => {
								// if (game.venueName === venue) {
								return (
									<tr key={key}>
										<td>
											{game.dayOfWeek}
											{', '}
											{game.date.substr(0, 2) === '01' &&
												'Jan. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '02' &&
												'Feb. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '03' &&
												'Mar. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '04' &&
												'Apr. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '05' &&
												'May ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '06' &&
												'June ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '07' &&
												'July ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '08' &&
												'Aug. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '09' &&
												'Sept. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '10' &&
												'Oct. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '11' &&
												'Nov. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '12' &&
												'Dec. ' + game.date.substr(3, 2)}
											{/* </td>									
									<td> */}
											{', '}
											{game.time.substr(0, 2) === '00' &&
												'12:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '01' &&
												'1:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '02' &&
												'2:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '03' &&
												'3:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '04' &&
												'4:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '05' &&
												'5:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '06' &&
												'6:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '07' &&
												'7:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '08' &&
												'8:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '09' &&
												'9:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '10' &&
												'10:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '11' &&
												'11:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '12' &&
												'12:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '13' &&
												'1:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '14' &&
												'2:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '15' &&
												'3:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '16' &&
												'4:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '17' &&
												'5:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '18' &&
												'6:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '19' &&
												'7:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '20' &&
												'8:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '21' &&
												'9:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '22' &&
												'10:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '23' &&
												'11:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '24' &&
												'12:' + game.time.substr(3, 2) + ' am '}
											{/* </td>
									<td> */}
											<br></br>
											{' @ '}
											<br></br>
											{game.venueName}
										</td>

										{game.visitorTeamName && (
											<td>
												{game.visitorTeamName && game.visitorTeamName}
												<br></br>
												{' @ '}
												<br></br>
												{game.homeTeamName && game.homeTeamName}
											</td>
										)}
										{game.eventName && (
											<td
												style={{
													fontWeight: 'bold',
													backgroundColor: 'pink',
												}}
											>
												{game.eventName}
											</td>
										)}
										{!game.playoff && !game.championship && <td></td>}
										{game.playoff && (
											<td style={{ color: 'red', fontWeight: 'bold' }}>
												{game.description}
											</td>
										)}

										{game.championship && (
											<td style={{ color: 'red', fontWeight: 'bold' }}>
												CHAMPIONSHIP GAME
											</td>
										)}
										{auth.isLoggedIn && (
											<td>
												{game.playoff &&
													game.homeTeamName &&
													game.homeTeamName !== 'TBD' &&
													game.visitorTeamName !== 'TBD' && (
														<NavLink
															className='navlinks'
															to={`/admin/playoffGameResults2/${game._id}`}
															exact
														>
															Results
														</NavLink>
													)}
												{game.championship &&
													game.homeTeamName &&
													game.homeTeamName !== 'TBD' &&
													game.visitorTeamName !== 'TBD' && (
														<NavLink
															className='navlinks'
															to={`/admin/championshipGameResults/${game._id}`}
															exact
														>
															Results
														</NavLink>
													)}
												{!game.playoff &&
													!game.championship &&
													game.homeTeamName &&
													game.homeTeamName !== 'TBD' &&
													game.visitorTeamName !== 'TBD' && (
														<NavLink
															className='navlinks'
															to={`/admin/gameResults2/${game._id}`}
															exact
														>
															Results
														</NavLink>
													)}
												{game.playoff &&
													!game.championship &&
													game.homeTeamName &&
													(game.homeTeamName === 'TBD' ||
														game.visitorTeamName === 'TBD') && (
														<NavLink
															className='navlinks'
															to={`/admin/updateGame/${game._id}`}
															exact
														>
															Enter Teams
														</NavLink>
													)}
											</td>
										)}
										{game.homeTeamId && game.winner === game.homeTeamId && (
											<td>{game.homeTeamName}</td>
										)}
										{game.visitorTeamId &&
											game.winner === game.visitorTeamId && (
												<td>{game.visitorTeamName}</td>
											)}
										{game.status &&
											game.status !== 'TBP' &&
											game.winner !== game.homeTeamId &&
											game.winner !== game.visitorTeamId && <td>TIE</td>}
										{!game.score && <td></td>}
										<td style={{ color: 'black', fontWeight: '600' }}>
											<Link
												style={{
													textDecoration: 'none',
													fontWeight: 600,
													color: 'black',
												}}
												to={`/gameSummary/${game._id}`}
											>
												{game.score}
												{game.status === 'Shootout' && ' (SO)'}
											</Link>
										</td>
									</tr>
								)
								//}
							})}
						</tbody>
					</table>
					<div className='scheduleCardsMobile' style={{ marginBottom: '6rem' }}>
						{allDivisionGamesAndEvents.map((game, key) => {
							const visitorLogo = teamLogoMap[game.visitorTeamName]
							const homeLogo = teamLogoMap[game.homeTeamName]

							return (
								<div
									className={`scheduleCard ${
										game.playoff || game.championship || game.description
											? 'scheduleCardPlayoff'
											: ''
									}`}
									key={`division-mobile-${key}`}
								>
									<div className='scheduleCard__header'>
										<div>{formatGameDate(game)}</div>

										<div className='scheduleCard__divisionHeader'>
											<div>
												{game.playoff ? 'PLAYOFF' : getDivisionLabel(game)}
											</div>

											{game.playoff && game.description && (
												<span className='scheduleCard__headerDescription'>
													{game.playoffDivision} - {game.description}
												</span>
											)}

											{!game.playoff && game.description && (
												<span className='scheduleCard__headerDescription'>
													{game.description}
												</span>
											)}
										</div>

										<div>{formatGameTime(game)}</div>
									</div>

									<div className='scheduleCard__body'>
										<div className='scheduleCard__team'>
											{homeLogo && (
												<img src={homeLogo} alt={game.homeTeamName} />
											)}
											<span
												className={
													game.winner === game.homeTeamId
														? 'scheduleCard__winnerPill'
														: ''
												}
											>
												{game.homeTeamName}
											</span>
										</div>

										<div className='scheduleCard__scoreBox'>
											{game.score ? (
												<Link
													to={`/gameSummary/${game._id}`}
													className='scheduleCard__score'
												>
													{getDisplayScore(game)}
												</Link>
											) : (
												<div className='scheduleCard__score'>TBP</div>
											)}

											{game.score && (
												<div className='scheduleCard__status'>
													{game.status === 'Shootout'
														? 'SO'
														: game.status === 'Overtime'
															? 'OT'
															: 'FINAL'}
												</div>
											)}
										</div>

										<div className='scheduleCard__team'>
											{visitorLogo && (
												<img src={visitorLogo} alt={game.visitorTeamName} />
											)}
											<span
												className={
													game.winner === game.visitorTeamId
														? 'scheduleCard__winnerPill'
														: ''
												}
											>
												{game.visitorTeamName}
											</span>
										</div>
									</div>

									<div className='scheduleCard__venue'>📍 {game.venueName}</div>

									{auth.isLoggedIn && (
										<div className='scheduleCard__admin'>
											{game.playoff &&
												game.homeTeamName &&
												game.homeTeamName !== 'TBD' &&
												game.visitorTeamName !== 'TBD' && (
													<NavLink
														className='navlinks'
														to={`/admin/playoffGameResults2/${game._id}`}
														exact
													>
														Results
													</NavLink>
												)}

											{game.championship &&
												game.homeTeamName &&
												game.homeTeamName !== 'TBD' &&
												game.visitorTeamName !== 'TBD' && (
													<NavLink
														className='navlinks'
														to={`/admin/championshipGameResults/${game._id}`}
														exact
													>
														Results
													</NavLink>
												)}

											{!game.playoff &&
												!game.championship &&
												game.homeTeamName &&
												game.homeTeamName !== 'TBD' &&
												game.visitorTeamName !== 'TBD' && (
													<NavLink
														className='navlinks'
														to={`/admin/gameResults2/${game._id}`}
														exact
													>
														Results
													</NavLink>
												)}

											{game.playoff &&
												!game.championship &&
												game.homeTeamName &&
												(game.homeTeamName === 'TBD' ||
													game.visitorTeamName === 'TBD') && (
													<NavLink
														className='navlinksEnterTeams'
														to={`/admin/updateGame/${game._id}`}
														exact
													>
														TEAMS
													</NavLink>
												)}
										</div>
									)}
								</div>
							)
						})}
					</div>
					<h3 className='divisionScheduleMobilePlayoffHeader'>
						{divisionName} Playoff Games
					</h3>

					<div className='scheduleCardsMobile'>
						{allPotentialPlayoffGames.map((game, key) => {
							const visitorLogo = teamLogoMap[game.visitorTeamName]
							const homeLogo = teamLogoMap[game.homeTeamName]

							return (
								<div
									className={`scheduleCard ${
										game.playoff || game.championship || game.description
											? 'scheduleCardPlayoff'
											: ''
									}`}
									key={`division-playoff-mobile-${key}`}
								>
									<div className='scheduleCard__header'>
										<div>{formatGameDate(game)}</div>

										<div className='scheduleCard__divisionHeader'>
											<div>
												{game.playoff ? 'PLAYOFF' : getDivisionLabel(game)}
											</div>

											{game.description && (
												<span className='scheduleCard__headerDescription'>
													{game.playoffDivision} - {game.description}
												</span>
											)}
										</div>

										<div>{formatGameTime(game)}</div>
									</div>

									<div className='scheduleCard__body'>
										<div className='scheduleCard__team'>
											{homeLogo && (
												<img src={homeLogo} alt={game.homeTeamName} />
											)}
											<span
												className={
													game.winner === game.homeTeamId
														? 'scheduleCard__winnerPill'
														: ''
												}
											>
												{game.homeTeamName}
											</span>
										</div>

										<div className='scheduleCard__scoreBox'>
											{game.score ? (
												<Link
													to={`/gameSummary/${game._id}`}
													className='scheduleCard__score'
												>
													{getDisplayScore(game)}
												</Link>
											) : (
												<div className='scheduleCard__score'>TBP</div>
											)}

											{game.score && (
												<div className='scheduleCard__status'>
													{game.status === 'Shootout'
														? 'SO'
														: game.status === 'Overtime'
															? 'OT'
															: 'FINAL'}
												</div>
											)}
										</div>

										<div className='scheduleCard__team'>
											{visitorLogo && (
												<img src={visitorLogo} alt={game.visitorTeamName} />
											)}
											<span
												className={
													game.winner === game.visitorTeamId
														? 'scheduleCard__winnerPill'
														: ''
												}
											>
												{game.visitorTeamName}
											</span>
										</div>
									</div>

									<div className='scheduleCard__venue'>📍 {game.venueName}</div>

									{auth.isLoggedIn && (
										<div className='scheduleCard__admin'>
											{game.playoff &&
												game.homeTeamName &&
												game.homeTeamName !== 'TBD' &&
												game.visitorTeamName !== 'TBD' && (
													<NavLink
														className='navlinks'
														to={`/admin/playoffGameResults2/${game._id}`}
														exact
													>
														Results
													</NavLink>
												)}

											{game.championship &&
												game.homeTeamName &&
												game.homeTeamName !== 'TBD' &&
												game.visitorTeamName !== 'TBD' && (
													<NavLink
														className='navlinks'
														to={`/admin/championshipGameResults2/${game._id}`}
														exact
													>
														Results
													</NavLink>
												)}

											{!game.playoff &&
												!game.championship &&
												game.homeTeamName &&
												game.homeTeamName !== 'TBD' &&
												game.visitorTeamName !== 'TBD' && (
													<NavLink
														className='navlinks'
														to={`/admin/gameResults2/${game._id}`}
														exact
													>
														Results
													</NavLink>
												)}

											{game.playoff &&
												!game.championship &&
												game.homeTeamName &&
												(game.homeTeamName === 'TBD' ||
													game.visitorTeamName === 'TBD') && (
													<NavLink
														className='navlinksEnterTeams'
														to={`/admin/updateGame/${game._id}`}
														exact
													>
														TEAMS
													</NavLink>
												)}
										</div>
									)}
								</div>
							)
						})}
					</div>
				</div>
				<div className='Schedule' style={{ marginBottom: '1rem' }}>
					<h3 className='h3Center teamScheduleDisplayTableTitle'>
						{divisionName} Playoff Games
					</h3>
					<table id='teamScheduleDisplay'>
						<thead>
							<tr>
								<th>Date/Time/Location</th>
								<th>Visitor/Home</th>
								<th></th>
								{auth.isLoggedIn && <th></th>}
								<th>Winner</th>
								<th>Score</th>
							</tr>
						</thead>
						<tbody>
							{allPotentialPlayoffGames.map((game, key) => {
								// if (game.venueName === venue) {
								return (
									<tr key={key}>
										<td>
											{game.dayOfWeek}
											{', '}
											{game.date.substr(0, 2) === '01' &&
												'Jan. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '02' &&
												'Feb. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '03' &&
												'Mar. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '04' &&
												'Apr. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '05' &&
												'May ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '06' &&
												'June ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '07' &&
												'July ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '08' &&
												'Aug. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '09' &&
												'Sept. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '10' &&
												'Oct. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '11' &&
												'Nov. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '12' &&
												'Dec. ' + game.date.substr(3, 2)}
											{/* </td>
									<td> */}
											{', '}
											{game.time.substr(0, 2) === '00' &&
												'12:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '01' &&
												'1:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '02' &&
												'2:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '03' &&
												'3:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '04' &&
												'4:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '05' &&
												'5:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '06' &&
												'6:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '07' &&
												'7:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '08' &&
												'8:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '09' &&
												'9:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '10' &&
												'10:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '11' &&
												'11:' + game.time.substr(3, 2) + ' am '}
											{game.time.substr(0, 2) === '12' &&
												'12:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '13' &&
												'1:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '14' &&
												'2:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '15' &&
												'3:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '16' &&
												'4:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '17' &&
												'5:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '18' &&
												'6:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '19' &&
												'7:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '20' &&
												'8:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '21' &&
												'9:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '22' &&
												'10:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '23' &&
												'11:' + game.time.substr(3, 2) + ' pm '}
											{game.time.substr(0, 2) === '24' &&
												'12:' + game.time.substr(3, 2) + ' am '}
											{/* </td>
									<td> */}
											<br></br>
											{' @ '}
											<br></br>
											{game.venueName}
										</td>
										{/* //
										//
										//    Visitor/Home
										//
										// */}
										{game.visitorTeamName && (
											<td>
												{game.visitorTeamName && game.visitorTeamName}
												<br></br>
												{' @ '}
												<br></br>
												{game.homeTeamName && game.homeTeamName}
												{game.description && (
													<div style={{ color: 'red', fontWeight: 'bold' }}>
														{'('}
														{game.description}
														{')'}
													</div>
												)}
											</td>
										)}
										{game.description && <td></td>}
										{auth.isLoggedIn && (
											<td>
												{game.playoff &&
													game.homeTeamName &&
													game.homeTeamName !== 'TBD' &&
													game.visitorTeamName !== 'TBD' && (
														<NavLink
															className='navlinks'
															to={`/admin/playoffGameResults2/${game._id}`}
															exact
														>
															Results
														</NavLink>
													)}
												{game.championship &&
													game.homeTeamName &&
													game.homeTeamName !== 'TBD' &&
													game.visitorTeamName !== 'TBD' && (
														<NavLink
															className='navlinks'
															to={`/admin/championshipGameResults2/${game._id}`}
															exact
														>
															Results
														</NavLink>
													)}
												{!game.playoff &&
													!game.championship &&
													game.homeTeamName &&
													game.homeTeamName !== 'TBD' &&
													game.visitorTeamName !== 'TBD' && (
														<NavLink
															className='navlinks'
															to={`/admin/gameResults2/${game._id}`}
															exact
														>
															Results
														</NavLink>
													)}
												{game.playoff &&
													!game.championship &&
													game.homeTeamName &&
													(game.homeTeamName === 'TBD' ||
														game.visitorTeamName === 'TBD') && (
														<NavLink
															className='navlinksEnterTeams'
															to={`/admin/updateGame/${game._id}`}
															exact
														>
															TEAMS
														</NavLink>
													)}
											</td>
										)}
										{/* //
										//
										//    Winner
										//
										// */}
										{game.homeTeamId && game.winner === game.homeTeamId && (
											<td>{game.homeTeamName}</td>
										)}
										{game.visitorTeamId &&
											game.winner === game.visitorTeamId && (
												<td>{game.visitorTeamName}</td>
											)}
										{game.status &&
											game.status !== 'TBP' &&
											game.winner !== game.homeTeamId &&
											game.winner !== game.visitorTeamId && <td>TIE</td>}
										{!game.score && <td></td>}
										{/* //
										//
										//    Score
										//
										// */}
										<td style={{ color: 'black', fontWeight: '600' }}>
											<Link
												style={{
													textDecoration: 'none',
													fontWeight: 600,
													color: 'black',
												}}
												to={`/gameSummary/${game._id}`}
											>
												{game.score}
												{game.status === 'Shootout' && ' (SO)'}
											</Link>
										</td>
									</tr>
								)
								//}
							})}
						</tbody>
					</table>
				</div>
			</React.Fragment>,
		)
		// }
		//)
	}

	return (
		<div style={{ overflowX: 'hidden' }}>
			<React.Fragment>
				<SchedulesHomeNavigation />
				<Banner />
				{/* <div style={{ marginBottom: '2rem', marginTop: '1rem' }}>
					<FilterByTeam leagueId={leagueId} />
				</div> */}
				<SearchByLeagueOrVenue />
				{dateBlock && dateBlock}
				<Footer />
			</React.Fragment>
		</div>
	)
}

export default DivisionSchedule
